import { createSelector } from 'reselect';

import { getProgressPercentComplete, isProgressStarted } from 'phoenix2/utils/completion';
import { getTaskItemName } from 'phoenix2/utils/task-item';

import { TASK_STATES_KEY, TASK_ITEM_STATES_KEY } from './reducers';

export const getTaskState = (state, taskId) => state.getIn([TASK_STATES_KEY, taskId]);

export const getTaskStates = state => state.get(TASK_STATES_KEY);

export const getTaskItemState = (state, taskItemId) =>
    state.getIn([TASK_ITEM_STATES_KEY, taskItemId]);

export const getTaskItemStates = (state, taskItems) => {
    const states = [];
    for (const item of taskItems) {
        const itemState = getTaskItemState(state, item.get('id'));
        const name = getTaskItemName(item, 'name');
        states.push({ name, state: itemState });
    }
    return states;
};

export function computeTaskStatus(taskState) {
    if (!taskState) {
        return {
            complete: false,
            unstarted: true,
            percentComplete: 0,
        };
    }

    return {
        complete: taskState.get('complete'),
        unstarted: !isProgressStarted(taskState),
        percentComplete: getProgressPercentComplete(taskState),
    };
}

export const makeSelectTaskStatus = () => createSelector([getTaskState], computeTaskStatus);
